import Container from "../../components/Container";
import Button from "../../components/Button";
import { Link } from "react-router-dom";
import styles from "../order/index.module.scss";
import { Helmet } from "react-helmet-async";

export default function OrderPage() {
    const localProductId = localStorage.getItem("localProductId");
    return (
        <>
            <Helmet>
                <title>決済エラー | 西部ガス</title>
                <meta name="description" content="決済処理中にエラーが発生しました。決済は完了しておりませんので、お手数ですが下記サイトから再度ご購入お手続きをお願いいたします。" />
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <div className={styles.orderPage}>
                <section className={styles.orderPage__errorSection}>
                    <Container>
                        <p
                            style={{
                                fontSize: "3.2rem",
                                textAlign: "center",
                            }}
                            className="noto-sans-jp-bold"
                        >
                            決済処理中にエラーが発生しました。
                        </p>
                        <p
                            style={{
                                fontSize: "2rem",
                                lineHeight: "1.8",
                                margin: "4rem 3rem 6rem",
                                textAlign: "center",
                            }}
                            className="noto-sans-jp-medium"
                        >
                            決済は完了しておりませんので、お手数ですが
                            <br />
                            下記サイトから再度ご購入お手続きをお願いいたします。
                        </p>
                        <div>
                            {localProductId ? (
                                <Button
                                    variant="white"
                                    className="noto-sans-jp-bold"
                                >
                                    <Link to={`/order/${localProductId}`}>
                                        注文情報入力へ戻る
                                    </Link>
                                </Button>
                            ) : (
                                <>
                                    <Button
                                        variant="white"
                                        className="noto-sans-jp-bold"
                                    >
                                        <Link to="/pr_tableconro"  style={{ display: "flex", flexDirection: "column" }}>
                                            <span>テーブルコンロ</span>
                                            <span>専用サイトに戻る</span>
                                        </Link>
                                    </Button>
                                    <Button
                                        variant="white"
                                        className="noto-sans-jp-bold"
                                    >
                                        <Link to="/pr_fh" style={{ display: "flex", flexDirection: "column" }}>
                                            <span>ガスファンヒーター</span>
                                            <span>専用サイトに戻る</span>
                                        </Link>
                                    </Button>
                                </>
                            )}
                        </div>
                    </Container>
                </section>
            </div>
        </>
    );
}
